/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListProvidersParams,
  PaginatedResponseVoucherProviderResponse,
  VoucherProviderCreate,
  VoucherProviderResponse,
  VoucherProviderUpdate
} from '../model';

import { apiInstance } from '../../lib/apiInstance';




/**
 * Create a new voucher provider (Admin only)
 * @summary Create Provider
 */
export const createProvider = (
    voucherProviderCreate: VoucherProviderCreate,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherProviderResponse>(
      {url: `/api/voucher-providers/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voucherProviderCreate, signal
    },
      );
    }



export const getCreateProviderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,{data: VoucherProviderCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,{data: VoucherProviderCreate}, TContext> => {

const mutationKey = ['createProvider'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProvider>>, {data: VoucherProviderCreate}> = (props) => {
          const {data} = props ?? {};

          return  createProvider(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProviderMutationResult = NonNullable<Awaited<ReturnType<typeof createProvider>>>
    export type CreateProviderMutationBody = VoucherProviderCreate
    export type CreateProviderMutationError = HTTPValidationError

    /**
 * @summary Create Provider
 */
export const useCreateProvider = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvider>>, TError,{data: VoucherProviderCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProvider>>,
        TError,
        {data: VoucherProviderCreate},
        TContext
      > => {
      return useMutation(getCreateProviderMutationOptions(options), queryClient);
    }
    /**
 * List voucher providers with pagination
 * @summary List Providers
 */
export const listProviders = (
    params?: ListProvidersParams,
 signal?: AbortSignal
) => {


      return apiInstance<PaginatedResponseVoucherProviderResponse>(
      {url: `/api/voucher-providers/`, method: 'GET',
        params, signal
    },
      );
    }




export const getListProvidersQueryKey = (params?: ListProvidersParams,) => {
    return [
    `/api/voucher-providers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProvidersQueryOptions = <TData = Awaited<ReturnType<typeof listProviders>>, TError = HTTPValidationError>(params?: ListProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProvidersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProviders>>> = ({ signal }) => listProviders(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof listProviders>>>
export type ListProvidersQueryError = HTTPValidationError


export function useListProviders<TData = Awaited<ReturnType<typeof listProviders>>, TError = HTTPValidationError>(
 params: undefined |  ListProvidersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProviders>>,
          TError,
          Awaited<ReturnType<typeof listProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProviders<TData = Awaited<ReturnType<typeof listProviders>>, TError = HTTPValidationError>(
 params?: ListProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProviders>>,
          TError,
          Awaited<ReturnType<typeof listProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProviders<TData = Awaited<ReturnType<typeof listProviders>>, TError = HTTPValidationError>(
 params?: ListProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Providers
 */

export function useListProviders<TData = Awaited<ReturnType<typeof listProviders>>, TError = HTTPValidationError>(
 params?: ListProvidersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviders>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProvidersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a specific voucher provider
 * @summary Get Provider
 */
export const getProvider = (
    providerId: string,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherProviderResponse>(
      {url: `/api/voucher-providers/${providerId}`, method: 'GET', signal
    },
      );
    }




export const getGetProviderQueryKey = (providerId: string,) => {
    return [
    `/api/voucher-providers/${providerId}`
    ] as const;
    }


export const getGetProviderQueryOptions = <TData = Awaited<ReturnType<typeof getProvider>>, TError = HTTPValidationError>(providerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProviderQueryKey(providerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvider>>> = ({ signal }) => getProvider(providerId, signal);





   return  { queryKey, queryFn, enabled: !!(providerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProviderQueryResult = NonNullable<Awaited<ReturnType<typeof getProvider>>>
export type GetProviderQueryError = HTTPValidationError


export function useGetProvider<TData = Awaited<ReturnType<typeof getProvider>>, TError = HTTPValidationError>(
 providerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvider>>,
          TError,
          Awaited<ReturnType<typeof getProvider>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvider<TData = Awaited<ReturnType<typeof getProvider>>, TError = HTTPValidationError>(
 providerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvider>>,
          TError,
          Awaited<ReturnType<typeof getProvider>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvider<TData = Awaited<ReturnType<typeof getProvider>>, TError = HTTPValidationError>(
 providerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Provider
 */

export function useGetProvider<TData = Awaited<ReturnType<typeof getProvider>>, TError = HTTPValidationError>(
 providerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProviderQueryOptions(providerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Update a voucher provider (Admin only)
 * @summary Update Provider
 */
export const updateProvider = (
    providerId: string,
    voucherProviderUpdate: VoucherProviderUpdate,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherProviderResponse>(
      {url: `/api/voucher-providers/${providerId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: voucherProviderUpdate, signal
    },
      );
    }



export const getUpdateProviderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,{providerId: string;data: VoucherProviderUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,{providerId: string;data: VoucherProviderUpdate}, TContext> => {

const mutationKey = ['updateProvider'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProvider>>, {providerId: string;data: VoucherProviderUpdate}> = (props) => {
          const {providerId,data} = props ?? {};

          return  updateProvider(providerId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProviderMutationResult = NonNullable<Awaited<ReturnType<typeof updateProvider>>>
    export type UpdateProviderMutationBody = VoucherProviderUpdate
    export type UpdateProviderMutationError = HTTPValidationError

    /**
 * @summary Update Provider
 */
export const useUpdateProvider = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProvider>>, TError,{providerId: string;data: VoucherProviderUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProvider>>,
        TError,
        {providerId: string;data: VoucherProviderUpdate},
        TContext
      > => {
      return useMutation(getUpdateProviderMutationOptions(options), queryClient);
    }
    /**
 * Soft delete a voucher provider (Admin only)
 * @summary Delete Provider
 */
export const deleteProvider = (
    providerId: string,
 signal?: AbortSignal
) => {


      return apiInstance<void>(
      {url: `/api/voucher-providers/${providerId}`, method: 'DELETE', signal
    },
      );
    }



export const getDeleteProviderMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,{providerId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,{providerId: string}, TContext> => {

const mutationKey = ['deleteProvider'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProvider>>, {providerId: string}> = (props) => {
          const {providerId} = props ?? {};

          return  deleteProvider(providerId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProviderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProvider>>>

    export type DeleteProviderMutationError = HTTPValidationError

    /**
 * @summary Delete Provider
 */
export const useDeleteProvider = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvider>>, TError,{providerId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProvider>>,
        TError,
        {providerId: string},
        TContext
      > => {
      return useMutation(getDeleteProviderMutationOptions(options), queryClient);
    }
